import { apiHolder, apis } from 'api';
import { isMainAccount } from '@web-mail/util';
import { FLOLDER } from '@web-mail/common/constant';
const systemApi = apiHolder.api.getSystemApi();
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const structHeightMap1 = {
    from: 20,
    summary: 22,
    desc: 22,
    attachments: 32,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 24,
};
const structHeightMap2 = {
    from: 16,
    summary: 20,
    desc: 20,
    attachments: 30,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 24,
};
const structHeightMap3 = {
    from: 16,
    summary: 18,
    desc: 18,
    attachments: 28,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 24,
};
const structHeightMap = [structHeightMap1, structHeightMap2, structHeightMap3];
const getVisibleStructHeight = (data) => {
    var _a, _b;
    const isCorpMail = systemApi.getIsCorpMailMode();
    const isFree = productAuthApi.doGetProductVersionId() === 'free';
    const isSirius = productAuthApi.doGetProductVersionId() === 'sirius';
    const isOther = productAuthApi.doGetProductVersionId() !== 'free' && productAuthApi.doGetProductVersionId() !== 'sirius';
    const tightness = mailConfApi.getMailListTightness();
    const { from, summary, desc, attachments, sendStatus, readStatus, taskDeadline } = structHeightMap[+tightness - 1];
    const isMainAcc = isMainAccount(data === null || data === void 0 ? void 0 : data._account);
    const res = {
        from,
        summary,
        desc,
    };
    if (data && ((_a = data.entry.attachment) === null || _a === void 0 ? void 0 : _a.length)) {
        let attachment = [];
        attachment = (_b = data.entry.attachment) === null || _b === void 0 ? void 0 : _b.filter(item => item.inlined === false && item.fileType !== 'ics' && item.type !== 'netfolder');
        if (attachment.length) {
            res.attachments = attachments;
        }
    }
    if (!isCorpMail && data && data.entry.sendStatus) {
        res.sendStatus = sendStatus;
    }
    if (!isCorpMail &&
        isMainAcc &&
        !isFree &&
        data &&
        data.entry.folder === FLOLDER.SENT &&
        !data.taskId &&
        ((isSirius && (data.entry.rcptCount || data.entry.readCount)) || (isOther && (data.entry.innerCount || data.entry.innerRead)))) {
        res.readStatus = readStatus;
    }
    if (!isCorpMail && data && data.taskId && data.taskInfo) {
        res.taskDeadline = taskDeadline;
        res.desc = null;
    }
    const showDesc = mailConfApi.getMailShowDesc();
    const showAttachment = mailConfApi.getMailShowAttachment();
    if (!showDesc) {
        res.desc = null;
    }
    if (!showAttachment) {
        res.attachments = null;
    }
    return res;
};
export const getCardHeight = (data) => {
    if (data) {
        let baseHeight = 0;
        const tightness = mailConfApi.getMailListTightness();
        if (+tightness === 1) {
            baseHeight = 24;
        }
        else if (+tightness === 2) {
            baseHeight = 20;
        }
        else if (+tightness === 3) {
            baseHeight = 16;
        }
        let sumHeight = baseHeight;
        const heightMap = getVisibleStructHeight(data);
        Object.values(heightMap).forEach(height => {
            sumHeight += height;
        });
        return sumHeight;
    }
    return 0;
};
export const getMailOrderRequestParam = (selectedTab) => {
    let orderBy = 'date';
    switch (selectedTab) {
        case 'ORDER_BY_SENDER_CAPITAL_DESC':
        case 'ORDER_BY_SENDER_CAPITAL_ASC':
            orderBy = 'from';
            break;
        case 'ORDER_BY_RECEIVER_CAPITAL_DESC':
        case 'ORDER_BY_RECEIVER_CAPITAL_ASC':
            orderBy = 'to';
            break;
        case 'ORDER_BY_SUBJECT_CAPITAL_ASC':
        case 'ORDER_BY_SUBJECT_CAPITAL_DESC':
            orderBy = 'subject';
            break;
        case 'ORDER_BY_SIZE_DESC':
        case 'ORDER_BY_SIZE_ASC':
            orderBy = 'size';
            break;
        default:
            break;
    }
    return orderBy;
};
export const needTimeRangeByMailOrderType = (selectedTab) => {
    let needTimeRange = false;
    switch (selectedTab) {
        case 'ORDER_BY_SENDER_CAPITAL_DESC':
        case 'ORDER_BY_SENDER_CAPITAL_ASC':
        case 'ORDER_BY_RECEIVER_CAPITAL_DESC':
        case 'ORDER_BY_RECEIVER_CAPITAL_ASC':
        case 'ORDER_BY_SUBJECT_CAPITAL_ASC':
        case 'ORDER_BY_SUBJECT_CAPITAL_DESC':
        case 'ORDER_BY_SIZE_DESC':
        case 'ORDER_BY_SIZE_ASC':
            needTimeRange = true;
            break;
        default:
            break;
    }
    return needTimeRange;
};
export const getMailOrderDescRequestParam = (selectedTab) => {
    let isDesc = true;
    switch (selectedTab) {
        case 'ORDER_BY_DATE_ASC':
        case 'ORDER_BY_SENDER_CAPITAL_ASC':
        case 'ORDER_BY_RECEIVER_CAPITAL_ASC':
        case 'ORDER_BY_SUBJECT_CAPITAL_ASC':
        case 'ORDER_BY_SIZE_ASC':
            isDesc = false;
            break;
        default:
            break;
    }
    return isDesc;
};
